import { render, staticRenderFns } from "./IsRateActive.vue?vue&type=template&id=24d3a036&"
import script from "./IsRateActive.vue?vue&type=script&lang=js&"
export * from "./IsRateActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports